namespace TabAurous.OMS {

    @Serenity.Decorators.registerEditor()
    export class POSCustomerMasterEditor extends Serenity.Select2Editor<any, any> {

            constructor(container: JQuery) {
            super(container, null);


                this.addOption("Male", "Male");
                this.addOption("Female", "Female");
                this.addOption("Others","Others");

        }
    }
}